<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <form class="form-horizontal sp-0" name="formSelectArticlesSearch" novalidate (ngSubmit)="retrieveChanges()" method="get" role="form">
            <tt-input ttRememberId="w_selectarticles.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
        </form>

        <tt-checkbox ttLabel="retrieve_only_selected" [(ttModel)]="setting.retrieve_only_selected" (ttModelChange)="onChanged($event, 'retrieve_only_selected')"></tt-checkbox>
        <tt-button ttText="selectarticles_retrieve" (ttClick)="retrieveChanges()" ttIcon="fas fa-sync"></tt-button>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
